import {app} from '../app';
import {ITranslationService} from "../services/TranslationService";
import {ISessionService} from "../services/SessionService";
import authService = require('../services/auth');
import {IBrowserControlService} from "../services/BrowserControlService";
import moment = require("moment/moment");

export class NavigationController {

    private rootScope:IRootScope;
    private location:ng.ILocationService;
    private translationService:ITranslationService;
    private sessionService:ISessionService;
    private browserControlService:IBrowserControlService;
    private authService:any;

    static $inject = ['$rootScope', '$location', 'TranslationService', 'SessionService', 'BrowserControlService', 'authService'];

    languages:ILanguage[];
    language:ILanguage;
    languageSelector:boolean = false;

    defaultLogos:any = {
        mobile : {
            main     : '/images/logo_lumina@2x.png',
            secondary: '',
        },
        desktop: {
            left : '/images/logo_lumina@2x.png',
            right: ''
        }
    };
    logos:any        = null;

    constructor($rootScope:IRootScope,
                $location:ng.ILocationService,
                TranslationService:ITranslationService,
                SessionService:ISessionService,
                BrowserControlService:IBrowserControlService,
                authService:any) {

        this.rootScope             = $rootScope;
        this.location              = $location;
        this.translationService    = TranslationService;
        this.sessionService        = SessionService;
        this.browserControlService = BrowserControlService;
        this.authService           = authService;

        this.translationService.onLanguageChange(() => {
            this.languages = this.translationService.getLanguages();
            this.language  = this.translationService.getCurrentLanguage();
            angular.element('#options-modal').modal('hide');
        });

        this.logos = this.defaultLogos;

        $rootScope.$on('headerLogos', (event, arg) => {
            const logos = (<IQuestionnaire>arg).meta.logos;
            if (!logos) {
                return;
            }

            const mobile = logos.mobile;
            if (mobile) {
                this.logos.mobile.main      = mobile.main ? mobile.main : this.defaultLogos.mobile.main;
                this.logos.mobile.secondary = mobile.secondary ? mobile.secondary : this.defaultLogos.mobile.secondary;
                this.logos.mobile.secondaryImageAlt = mobile.secondaryImageAlt ? mobile.secondaryImageAlt : '';
            }

            const desktop = logos.desktop;
            if (desktop) {
                this.logos.desktop.left  = desktop.left ? desktop.left : this.defaultLogos.desktop.left;
                this.logos.desktop.right = desktop.right ? desktop.right : this.defaultLogos.desktop.right;
                this.logos.desktop.rightImageAlt = desktop.rightImageAlt ? desktop.rightImageAlt : '';
            }
        });
    }

    languageChange() {
        this.translationService.setCurrentLanguage(this.language);
    }

    showOptionsModal() {
        this.sessionService.ready(() => {
            angular.element('#options-modal').modal({
                keyboard: false,
                backdrop: 'static'
            }).modal('show');

            this.sessionService.sessionPaused();
        });
    }

    onOptionsCancel() {
        angular.element('#options-modal').modal('hide');

        this.sessionService.sessionResumed();
    }

    onOptionsSignOut() {
        this.browserControlService.enableBackButton();

        // Log out locally
        this.authService.logoutLocally();
    }

    onOptionsLeaveQuestionnaire() {
        this.sessionService.exitRedirect();
    }
}

app.controller('NavigationController', NavigationController);
